module.exports = __webpack_public_path__ + "static/media/w_b_0.b4065e05.png";